module.exports = __webpack_public_path__ + "static/media/max-sky-blue.f011a860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/airpods/max-sky-blue.png
// module id = 2059
// module chunks = 0